import { apolloClient } from "@/plugins/apollo";
import gql from "fraql";
import { buildMasterdataHelper } from "./factory";
export const MasterCountryFragment = gql `
  fragment _ on Country {
    id
    name
    nameTranslations {
      locale
      value
    }
    alpha2
    ioc
    inEuVat # used in VAT validation
  }
`;
export function useCountryHelper() {
    function getCountries() {
        var _a, _b;
        return ((_b = (_a = apolloClient.readQuery({
            query: gql `
          query countries {
            countries {
             ${MasterCountryFragment}
            }
          }
        `
        })) === null || _a === void 0 ? void 0 : _a.countries) !== null && _b !== void 0 ? _b : []);
    }
    const { masterdataEntities, getFromMasterdata, addMissingSelectValue } = buildMasterdataHelper(getCountries);
    return {
        masterCountries: masterdataEntities,
        getCountryFromMaster: getFromMasterdata,
        withMissingCountrySelect: addMissingSelectValue
    };
}
